const o = {
  thousand: 1e3,
  million: 1e6,
  billion: 1e9
}, s = (t, n) => new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: n
}).format(t), l = (t, n = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: n
}).format(t / o.thousand)}K`, u = (t, n = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: n
}).format(t / o.million)}M`, i = (t, n = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: n
}).format(t / o.billion)}B`, c = (t, n) => {
  const r = Math.abs(t);
  return r >= o.billion ? i : r >= o.million ? u : n && r >= o.thousand ? l : s;
}, f = ({
  number: t,
  maximumFractionDigits: n,
  shorten: r = !0,
  formatThousands: e = !1
}) => {
  const a = Math.abs(t), m = r ? c(a, e) : s;
  return `${t < 0 ? "-" : ""}${m(a, n)}`;
}, b = (t) => new Intl.NumberFormat("en-US").format(t), d = (t, n = "auto") => {
  const r = Math.abs(t);
  let e = 1e3;
  for (; t; ) {
    if (r / e < 1)
      return t;
    if (r / e < 1e3)
      switch (n) {
        case "up":
          return Math.ceil(t / e) * e;
        case "down":
          return Math.floor(t / e) * e;
        default:
          return Math.round(t / e) * e;
      }
    e = e * 1e3;
  }
  return t;
};
export {
  o as MAGNITUDES,
  i as formatBillions,
  s as formatDefault,
  u as formatMillions,
  l as formatThousands,
  f as numberFormat,
  b as numberFormatCommas,
  d as roundToWholeNumber
};
//# sourceMappingURL=index.es278.js.map
